import React from 'react'

const HighlightText = ({text}) => {
  return (

    <span className='text-caribbeangreen-50  font-bold'>
    {" "}
    {text}
    {" "}
    </span>

    
  )
}

export default HighlightText
